import { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "miora-bag-v1";
const BagContext = createContext(null);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export function BagProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, size, color, qty = 1) => {
    const key = `${product.slug}|${size}|${color}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      }
      return [
        ...prev,
        {
          key,
          slug: product.slug,
          name: product.name,
          price: product.price,
          gradient: product.gradient,
          size,
          color,
          qty,
        },
      ];
    });
  };

  const setQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.key !== key)
        : prev.map((i) => (i.key === key ? { ...i, qty: Math.min(20, qty) } : i))
    );

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  const value = useMemo(
    () => ({ items, add, setQty, remove, clear, count, subtotal }),
    [items]
  );

  return <BagContext.Provider value={value}>{children}</BagContext.Provider>;
}

export const useBag = () => useContext(BagContext);
